import type {
    AnatomySampleMap
} from "../types";
import {
    AnimatedIcon,
    AvatarGroup,
    Separator,
    Progress,
    Skeleton,
    Marker,
    Avatar,
    Badge,
    Icon,
    Chip,
    Text,
    Kbd
} from "ncore-ui-kit";
import {
    Bell as BellIcon,
    Menu as MenuIcon,
    X as XIcon
} from "lucide-react-native";
import {
    shapeConfigs
} from "../sampleTokens";
import {
    CheckIcon,
    StarIcon
} from "../icons";

const renderChip = (title: string, isSelected: boolean) => {
    return <Chip
        onClose={() => undefined}
        onPress={() => undefined}
        isSelected={isSelected}
        icon={StarIcon}
        title={title}
    />;
};

const renderAnimatedIcon = (isTransitioned: boolean) => {
    return <AnimatedIcon
        isTransitioned={isTransitioned}
        iconTransition="morph"
        fromIcon={MenuIcon}
        toIcon={XIcon}
        size="large"
    />;
};

export const basicPrimitiveSamples: AnatomySampleMap = {
    Chip: (t) => ({
        states: [
            {
                node: renderChip(t("sample.label"), false),
                label: t("sample.stateDefault")
            },
            {
                node: renderChip(t("sample.label"), true),
                label: t("sample.stateActive")
            }
        ]
    }),
    AnimatedIcon: (t) => ({
        states: [
            {
                label: t("sample.stateClosed"),
                node: renderAnimatedIcon(false)
            },
            {
                node: renderAnimatedIcon(true),
                label: t("sample.stateOpen")
            }
        ]
    }),
    Progress: (t) => ({
        node: <Progress
            description={t("sample.fileSize")}
            title={t("sample.fileName")}
            value={64}
        />,
        width: shapeConfigs.drawerWidth
    }),
    Badge: (t) => ({
        node: <Badge
            title={t("sample.statusActive")}
            icon={CheckIcon}
            type="success"
        />
    }),
    Skeleton: () => ({
        width: shapeConfigs.sideListWidth,
        node: <Skeleton
            animation="none"
            variant="text"
            lines={3}
        />
    }),
    Separator: () => ({
        width: shapeConfigs.drawerWidth,
        node: <Separator
            isShowTitle={true}
        />
    }),
    Text: (t) => ({
        node: <div
            style={{
                display: "flex"
            }}
        >
            <Text
                variant="titleLargeSize"
                color="high"
            >
                {t("sample.title")}
            </Text>
        </div>
    }),
    Marker: (t) => ({
        node: <Marker
            icon={BellIcon}
        >
            {t("sample.notification")}
        </Marker>
    }),
    Kbd: () => ({
        node: <Kbd
            displayBehaviour="always"
            keys="shift+enter"
            platform="other"
        />
    }),
    Avatar: (t) => ({
        node: <Avatar
            title={t("sample.name")}
            isStatusIndicator={true}
        />
    }),
    AvatarGroup: (t) => ({
        node: <AvatarGroup
            avatars={[
                t("sample.name"),
                t("sample.option1"),
                t("sample.option2"),
                t("sample.option3"),
                t("sample.item1"),
                t("sample.item2")
            ].map((title) => ({
                title
            }))}
        />
    }),
    Icon: () => ({
        node: <Icon
            icon={BellIcon}
            size="large"
        />
    })
};
